'use strict';

/*global isEmpty*/

(function ($) {
  var methods = {
    init: function (options) {

      options = $.extend({}, $.fn.k2_countdown.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('countdown-init')) {
          return;
        }

        $this.addClass('countdown-init');
        if (!$this.data('actual')) {
          $this.data('actual', options.duration);
        }

        var intevalId = setInterval(function () {
          if (!$this.hasClass('countdown-pause')) {
            var actual = $this.data('actual');

            if (actual <= 0) {
              if (!isEmpty(options.callback)) {
                options.callback($this);
              }

              if (options.repeat) {
                actual = options.duration + options.intervalStep;
              } else {
                clearInterval(intevalId);
              }
            }

            $this.data('actual', actual - options.intervalStep);
            $this.css({ width: ((actual - options.intervalStep) / options.duration) * 100 + '%' });
          }
        }, options.intervalStep);
      });
    }
  };

  $.fn.k2_countdown = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_countdown');
    }

  };

  $.fn.k2_countdown.defaults = {
    intervalStep: 1000, //v ms
    duration: 60000, //v ms
    repeat: false, //po dobehnuti opakovat
    callback: null //callback pri dobehnuti
  };

})(jQuery);
